<template>
  <div class="space-x-2">
    <span
      v-if="totalSent"
      class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800"
    >
      {{ totalSent }}/{{ total }} sent
    </span>
    <span
      v-if="totalAccepted"
      class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-indigo-100 text-indigo-800"
    >
      {{ totalAccepted }}/{{ total }} accepted
    </span>
    <span
      v-if="totalDelivered"
      class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800"
    >
      {{ totalDelivered }}/{{ total }} delivered
    </span>
  </div>
</template>

<script>
export default {
  props: {
    messageThirdPartyServices: {
      type: Array,
      required: true,
    },
  },
  computed: {
    total() {
      return this.messageThirdPartyServices.length;
    },
    totalSent() {
      return this.messageThirdPartyServices.filter((messageThirdPartyService) => {
        if (typeof messageThirdPartyService.payload?.status === 'undefined') {
          return false;
        }

        return messageThirdPartyService.payload.status === '0';
      }).length;
    },
    totalAccepted() {
      return this.messageThirdPartyServices.filter((messageThirdPartyService) => {
        if (typeof messageThirdPartyService.payload?.status === 'undefined') {
          return false;
        }

        return messageThirdPartyService.payload.status === 'accepted';
      }).length;
    },
    totalDelivered() {
      return this.messageThirdPartyServices.filter((messageThirdPartyService) => {
        if (typeof messageThirdPartyService.payload.status === 'undefined') {
          return false;
        }

        return messageThirdPartyService.payload.status === 'delivered';
      }).length;
    },
  },
};
</script>
